/* eslint "react-hooks/exhaustive-deps": "off" */
import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import BarGraph from "@components/graphStatistics/Bar/Graphs";

import { ABSENCE, MALADIE, VACANCE } from "@helpers/_constants";

import {
  getRemainingHolidays,
  getUsedHolidays,
  graphOptions,
  graphPlugins,
} from "./congeGraphHelper";

export default function CongeGraph({ conges, holidayList  }) {
  const { t: statTranslator } = useTranslation("pages.employés.statistics");
  const [graphData, setGraphData] = useState({});

  useEffect(() => {
    /** @type {import("react-chartjs-2").ChartData<Chart.ChartData>} */
    const dataConge = {
      labels: conges?.map((x) => x.fullname) || [],
      datasets: [
        // Vacances
        {
          label: statTranslator("Vacance utilisés"),
          backgroundColor: "#FFB1C1",
          data: conges?.map((x) => getUsedHolidays(x.employeHolidays, VACANCE, holidayList)),
          stack: "1",
        },
        {
          label: statTranslator("Vacance restantes"),
          backgroundColor: "rgba(255, 176, 193, 0.46)",
          borderColor: "#E5879F",
          borderWidth: 0.5,
          data:
            conges?.map((x) =>
              getRemainingHolidays(x.employeHolidays, VACANCE, holidayList),
            ) || [],
          stack: "1",
        },

        //Maladie
        {
          label: statTranslator("Maladie utilisés"),
          backgroundColor: "#99D0F6",
          data:
            conges?.map((x) => getUsedHolidays(x.employeHolidays, MALADIE, holidayList)) ||
            [],
          stack: "2",
        },
        {
          label: statTranslator("Maladie restantes"),
          backgroundColor: "rgba(153, 208, 246, 0.46)",
          borderColor: "#79A9CD",
          borderWidth: 0.5,
          data:
            conges?.map((x) =>
              getRemainingHolidays(x.employeHolidays, MALADIE, holidayList),
            ) || [],
          stack: "2",
        },

        // Absence
        {
          label: statTranslator("Absence utilisés"),
          backgroundColor: "#FFE7AB",
          data:
            conges?.map((x) => getUsedHolidays(x.employeHolidays, ABSENCE, holidayList)) ||
            [],
          stack: "3",
        },
        {
          label: statTranslator("Absence restantes"),
          backgroundColor: "rgba(255, 231, 171, 0.46)",
          borderColor: "#FFD671",
          borderWidth: 0.5,
          data:
            conges?.map((x) =>
              getRemainingHolidays(x.employeHolidays, ABSENCE, holidayList),
            ) || [],
          stack: "3",
        },
      ],
    };

    setGraphData(dataConge);
  }, [conges]);

  return (
    <BarGraph
      // @ts-ignore
      legends={
        <div className="arh-flex arh-flex-col arh-space-y-2">
          <div className="arh-flex arh-items-center arh-space-x-3">
            <span className="arh-h-3 arh-w-3 arh-bg-[#ffb1c1]"></span>
            <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
              {statTranslator("Vacances")}
            </span>
          </div>
          <div className="arh-flex arh-items-center arh-space-x-3">
            <span className="arh-h-3 arh-w-3 arh-bg-[#99d0f6]"></span>
            <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
              {statTranslator("Maladie")}
            </span>
          </div>
          <div className="arh-flex arh-items-center arh-space-x-3">
            <span className="arh-h-3 arh-w-3 arh-bg-[#ffe7ab]"></span>
            <span className="arh-font-poppins arh-text-xs arh-font-medium arh-text-darkColor">
              {statTranslator("Absences")}
            </span>
          </div>
        </div>
      }
      graphData={graphData}
      title={statTranslator("Prise de congés")}
      graphOptions={graphOptions}
      graphPlugins={graphPlugins}
      target="conge"
    />
  );
}
